const netScheme = import.meta.env.VITE_APP_NET_SCHEME;
const hostName = import.meta.env.VITE_APP_API_BASE_URL;
// Only set for local development
const bffServicePort = import.meta.env.VITE_APP_BFF_SERVICE_PORT;
const baseUrl = `${netScheme}://${hostName}`;
export const bffServiceUrl = bffServicePort
  ? `${baseUrl}:${bffServicePort}`
  : baseUrl;
